<template>
    <div>
        <div class="applicationTitle">
            <span class="spanTitle uppercase">{{ getTranslate(app.terms.name) }}</span>
        </div>

        <div class="row">
            <div class="col-sm-3 col-sm-offset-1">
                <p class="allSelectTitle uppercase">{{ $t("common.selectAll") }} :</p>
            </div>
            <div class="col-sm-6 d-flex justify-content-around">
                <ClientColorButton :size="'s'" v-for="role in getRolesComplete" :key="role.id" @click="applyRoleForFunctionalities(role);">
                    {{ getTranslate(role.terms.name) }}</ClientColorButton
                >
                <ClientColorButton :size="'s'" @click="applyRoleForFunctionalities({ id: null });"> {{ $t("userrole.none") }}</ClientColorButton>
            </div>
        </div>
        <div class="row">
            <FunctionalitySection
                v-for="(funct, index) in app.functionalities"
                :listRoles="getRolesComplete"
                :funct="funct"
                :key="index"
                :currentRole="getAccessObject(funct)"
                @updateRole="changeRole"
            >
            </FunctionalitySection>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import cacheService from "@/services/cache";
import FunctionalitySection from "@/components/admin/user/FunctionalitySection";

export default {
    data: () => ({
        functionalities: [],
        localAccess: undefined
    }),
    components: {
        FunctionalitySection
    },
    async created() {
        await this.findAllRolesComplet();
        this.app.functionalities.map(func => ({ ...func, model: undefined }));
    },
    props: {
        app: {
            type: Object,
            required: true
        },
        access: {
            type: Array,
            required: true
        }
    },
    methods: {
        applyRoleForFunctionalities(role) {
            const functionalities = this.app.functionalities;
            for (const functionality of functionalities) {
                this.changeRole(functionality, role);
            }
        },
        getAccessObject(funct) {
            const accessObj = this.access.find(obj => obj.applicationFunctionnality.id === funct.id);
            return (accessObj && accessObj.userRole && accessObj.userRole.id) || null;
        },
        changeRole(functionality, role) {
            let localAccess = this.access;
            if (localAccess.find(la => la.applicationFunctionnality.id === functionality.id)) {
                localAccess.forEach((la, index) => {
                    if (la.applicationFunctionnality.id === functionality.id) {
                        localAccess[index].userRole.id = role.id;
                    }
                });
            } else {
                let element = {
                    id: null,
                    applicationFunctionnality: {
                        id: functionality.id
                    },
                    userRole: {
                        id: role.id
                    }
                };
                localAccess.push(element);
            }

            this.$emit("changeRole", localAccess);
        },
        ...mapActions({
            findAllRolesComplet: "roles/findAllRolesComplet"
        })
    },
    computed: {
        ...mapGetters({
            getRolesComplete: "roles/getRolesComplete",
            getFunctionalitiesAccess: "user/getFunctionalitiesAccess"
        })
    }
};
</script>

<style scoped lang="scss">
.applicationTitle {
    font-family: "Oswald", Sans-Serif;
    font-size: 18px;
    border-bottom: 1px solid #6f6f6f;
    color: #6f6f6f;
    padding: 5px 0;
    margin: 10px 0;
    .spanTitle {
        font-size: 18px;
    }
    .allSelectTitle {
        font-size: 14px;
    }
}
</style>



// WEBPACK FOOTER //
// AppSection.vue?13ce4844